export class CurrencyTypeVM {
    name: string;   
    code: string;
}
